import React, { Component, Fragment } from 'react';

import PropTypes from 'prop-types';

import {
  connect
} from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  SongRow
} from '../../components';

import {
  FavoriteH1,
  CitTable
} from '../../components/HelperComponents/StyledComponents';

import {
  SongTableHeader
} from '../../components/HelperComponents/HelperComponents';

import {
  playlistReplace,
} from '../../actions/PlaylistActions';

import {
  getSonglistHash,
} from '../../helpers';

const getSongsFromFavProps = props => {
  return (props.favorites && props.favorites.items) || [];
};

class FavoritesComponent extends Component {
  static propTypes = {
    children: PropTypes.any,
    match: PropTypes.any,
    location: PropTypes.any,
    history: PropTypes.any,
    user: PropTypes.object
  };

  componentDidMount() {
    if (!this.props.user.authenticated) {
      return this.props.history.push('/');
    }
  }

  componentDidUpdate(prevProps) {
    this.checkForUpdatedSongs(this.props, prevProps);
  }

  checkForUpdatedSongs(props, prevProps) {
    const songs = getSongsFromFavProps(props);
    const songsPrev = getSongsFromFavProps(prevProps);

    if (getSonglistHash(songs) !== getSonglistHash(songsPrev)) {
      this.props.playlistReplace(songs);
    }
  }

  render() {
    const currentSongId = this.props.currentSong && this.props.currentSong.id;
    const songs = this.props.favorites.items || [];
    const allSongs = songs.map((cov, i) => {
      const song = cov ? cov : {};
      const isActive = song.id && song.id === currentSongId;
      const isLoading = isActive && this.props.isLoading;
      const isPlaying = isActive && this.props.isPlaying;

      return (
        <SongRow
          key={'songRow_favorite' + i}
          song={song}
          numeration={i}
          isActive={isActive}
          isLoading={isLoading}
          isPlaying={isPlaying}
          shouldShowAlbumCover={true}
          shouldLinkAlbumTitle={true}
      />)
    });

    return (
      <Fragment>
        <section className="column is-11">
          <FavoriteH1>
            My Favorites
          </FavoriteH1>

          <CitTable className="table is-fullwidth has-text-white" theme={{ tableRowBackgroundColor: '#191919' }}>
            <SongTableHeader/>
            <tbody className="is-hoverable">
              {allSongs}
            </tbody>
          </CitTable>
        </section>
      </Fragment>
    );
  }
}


const getVisibleResults = (results, filter) => {
  if (!filter) return results;

  let filteredResults = results.filter((res) => {
    let isValid = filter.every((fil, i) => {
      if (res[`product_${fil.type}`] && res[`product_${fil.type}`].length && res[`product_${fil.type}`].find((product, i) => product.slug === fil.filter || product.post_name === fil.filter)) {
        return true;
      } else {
        return false;
      }
    });

    return isValid;
  });

  return filteredResults;
}

function mapStateToProps(state) {
  const {
    user,
    filters,
    favorites,
    playerSong,
  } = state;

  let filtered = { ...favorites, items: [...getVisibleResults(favorites.items, filters.selected)] };

  const {
    isPlaying,
    isLoading,
    currentSong,
  } = playerSong || {
    currentSong: null,
    isPlaying: false,
    isLoading: false,
  };

  return {
    favorites: filtered,
    currentSong,
    isPlaying,
    isLoading,
    filters,
    user,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    playlistReplace,
  }, dispatch);
}

export const Favorites = connect(mapStateToProps, mapDispatchToProps)(FavoritesComponent);



// WEBPACK FOOTER //
// ./src/routes/Favorites/Favorites.js